import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function notificarBaixaLote(promise) {
  return promise
    .catch(err => {
      Vue.$toast({
        component: ToastificationContent,
        props: {
          title: 'Erro ao solicitar a baixa em lote.',
          icon: 'fa-solid fa-circle-exclamation',
          variant: 'danger',
        },
      })
      throw err
    })
}
